import { useMutation } from '@tanstack/react-query';
import { getByAlternativeID } from "@/api/alternative"; 
import { GetAlternativeQuery } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useGetAlternative(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, GetAlternativeQuery>({
    mutationFn: getByAlternativeID,
    onSuccess,
    onError
  });
}